import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-13b32aac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mx-auto" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-white text-3xl" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-gear" })
], -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: "submenu",
  class: "absolute bottom-16 right-6 md:right-9"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "text-white text-xl" }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  key: "submenu",
  class: "absolute bottom-[5.5rem] right-2"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "text-white text-xl" }

import { computed, reactive, ref, Ref } from "vue";
import HelperModal from "@/components/Menu/HelperModal.vue";
import { useDialogsStore } from "@/Store/useDialogsStore";
import { useGameStore } from "@/Store/useGameStore";
import { GameStates } from "@/Interfaces/GameStates";
import { ComputedRef } from "vue/dist/vue";
import ModalStopGame from "@/components/Modals/ModalStopGame.vue";
import ModalPlayers from "@/components/Modals/ModalPlayers.vue";
import ModalNumberDrinks from "@/components/Modals/ModalNumberDrinks.vue";
import ModalCategories from "@/components/Modals/ModalCategories.vue";
import ModalCustomActions from "@/components/Modals/ModalCustomActions.vue";
import ModalSuggestionActions from "@/components/Modals/ModalSuggestionActions.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'MenuWithSmallMenus',
  setup(__props) {

/* Inspiré de : https://play.vuejs.org/#eNp9UstOwzAQ/BXjCyDRBKniUtKKh3qAAyDo0ZfgblO3jm3Zm7RV1X9nHUelSKineGdnxrMb7/mjc1nbAB/xIkivHLIA2LiJMKp21iPbMw8LdmALb2t2SdRLYYSR1gSiLu2GjSPhCn0D18IUeXIhPRUItdMlAlWMFd8NojXsQWol12PBe/VF/Ao+mdmq0lDkiZYkM1+aoFD1NSGOtQO16NWkWoLWtshjYOrmfwRFfhKAyoA7HY9ZOwCD4AelRNXCTYdoKFvoEbaPbnj0GjHrSqlwx26zu8CgDHAvzCGaHr3ifk6d0CaXXjlit0lCG+pi8BuOgda4UFW2CtbQH+j4gktbO6XBv7t4dxB8lJxir6RpN68dFjdOFyZcLkGu/8FXYRsxwT88BPAtCH7sYekrwNSefr3Bls7HZm3njSb2meYnBKubmDHRnhozp9gnvC7tS/eOlKlmYbpFoJX2Q8WgkXno+ILT23o+M/pv3GE27HS0T374AbBs70k= */

const isOpen: Ref<boolean> = ref(false);

const gameStore = useGameStore();
const dialogsStore = useDialogsStore();
const helper = dialogsStore.createNewDialog();
const playersDialog = dialogsStore.createNewDialog();
const stopGameDialog = dialogsStore.createNewDialog();
const numberDrinksDialog = dialogsStore.createNewDialog();
const categoriesDialog = dialogsStore.createNewDialog();
const actionsCustomDialog = dialogsStore.createNewDialog();
const actionsSuggestionsDialog = dialogsStore.createNewDialog();

const inGame: ComputedRef<number> = computed(() => {
  return gameStore.inGame;
});

const subMenus: { icon: string; action: () => void; inGameOnly: boolean }[] =
  reactive([
    {
      icon: "bi-box-arrow-left",
      action: () => {
        dialogsStore.openModal(stopGameDialog);
        isOpen.value = false;
      },
      inGameOnly: true,
    },
    {
      icon: "bi-person-gear",
      action: () => {
        dialogsStore.openModal(playersDialog);
        isOpen.value = false;
      },
      inGameOnly: true,
    },
    {
      icon: "bi-cup-straw",
      action: () => {
        dialogsStore.openModal(numberDrinksDialog);
        isOpen.value = false;
      },
      inGameOnly: true,
    },
    {
      icon: "bi-card-checklist",
      action: () => {
        dialogsStore.openModal(categoriesDialog);
        isOpen.value = false;
      },
      inGameOnly: true,
    },
    {
      icon: "bi-plus-circle",
      action: () => {
        dialogsStore.openModal(actionsCustomDialog);
        isOpen.value = false;
      },
      inGameOnly: false,
    },
    {
      icon: "bi-plus-circle-dotted",
      action: () => {
        dialogsStore.openModal(actionsSuggestionsDialog);
        isOpen.value = false;
      },
      inGameOnly: false,
    },
    {
      icon: "bi-info-lg",
      action: () => {
        dialogsStore.openModal(helper);
        isOpen.value = false;
      },
      inGameOnly: false,
    },
  ]);

const toggleMenu = () => {
  isOpen.value = !isOpen.value;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["w-16 h-16 rounded-full flex justify-center items-center cursor-pointer transition-transform duration-1000 ease-in-out transform bg-gradient-to-b from-gray-900 to-gray-800", { 'rotate-45': isOpen.value, 'rotate-0': !isOpen.value }]),
        onClick: toggleMenu
      }, _hoisted_3, 2),
      _createVNode(_Transition, null, {
        default: _withCtx(() => [
          (inGame.value === _unref(GameStates).Started)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                (isOpen.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subMenus, (subMenu, index) => {
                        return (_openBlock(), _createElementBlock("div", { key: index }, [
                          _createElementVNode("div", {
                            onClick: subMenu.action,
                            class: "w-12 h-12 rounded-full flex justify-center items-center cursor-pointer mb-4 bg-gradient-to-b from-gray-900 to-gray-800"
                          }, [
                            _createElementVNode("span", _hoisted_7, [
                              _createElementVNode("i", {
                                class: _normalizeClass(["bi", subMenu.icon])
                              }, null, 2)
                            ])
                          ], 8, _hoisted_6)
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                (isOpen.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subMenus, (subMenu, index) => {
                        return (_openBlock(), _createElementBlock("div", { key: index }, [
                          (!subMenu.inGameOnly)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                onClick: subMenu.action,
                                class: "w-12 h-12 rounded-full flex justify-center items-center cursor-pointer mb-4 bg-gradient-to-b from-gray-900 to-gray-800"
                              }, [
                                _createElementVNode("span", _hoisted_11, [
                                  _createElementVNode("i", {
                                    class: _normalizeClass(["bi", subMenu.icon])
                                  }, null, 2)
                                ])
                              ], 8, _hoisted_10))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]))
        ]),
        _: 1
      })
    ]),
    _createVNode(ModalStopGame, { "dialog-id": _unref(stopGameDialog) }, null, 8, ["dialog-id"]),
    _createVNode(ModalNumberDrinks, { "dialog-id": _unref(numberDrinksDialog) }, null, 8, ["dialog-id"]),
    _createVNode(ModalPlayers, { "dialog-id": _unref(playersDialog) }, null, 8, ["dialog-id"]),
    _createVNode(ModalCategories, { "dialog-id": _unref(categoriesDialog) }, null, 8, ["dialog-id"]),
    _createVNode(ModalCustomActions, { "dialog-id": _unref(actionsCustomDialog) }, null, 8, ["dialog-id"]),
    _createVNode(ModalSuggestionActions, { "dialog-id": _unref(actionsSuggestionsDialog) }, null, 8, ["dialog-id"]),
    _createVNode(HelperModal, { "dialog-id": _unref(helper) }, null, 8, ["dialog-id"])
  ], 64))
}
}

})